module.exports = __webpack_public_path__ + "img/redculture11.8185d300.jpg";